import React, { useState } from 'react';
import Popup from '../Popup/Popup';
import { Select, MenuItem, FormControl, Checkbox, ListItemText } from '@mui/material';
import { sendMessage } from '../../api/messaging';
import { useLoader } from '../../hooks/LoaderContext';

interface ContactPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (message: string, recipient: string[]) => void;
}

const ContactPopup: React.FC<ContactPopupProps> = ({ isOpen, onClose, onSubmit }) => {
  const { setIsLoading } = useLoader();
  const [message, setMessage] = useState('');
  const [recipients, setRecipients] = useState<string>('Branch');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleClose = () => {
    setMessage('');
    setRecipients('Branch');
    setIsSubmitted(false);
    onClose();
  };

  const handleSubmit = async () => {
    if (message.trim() && recipients) {
      try {
        setIsLoading(true);
        setError(null);

        await sendMessage({
          RecipientType: recipients.toUpperCase() as 'BRANCH' | 'PAYROLL',
          MessageContent: message
        });

        setIsSubmitted(true);
        onSubmit(message, [recipients]);
      } catch (err) {
        setError('Failed to send message. Please try again.');
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    }
  };

  if (!isOpen) return null;

  return (
    <Popup width="35vw" onClose={handleClose}>
      <h2 className="contact-title">Contact Us</h2>
      {isSubmitted ? (
        <>
          <p></p>
          <h2 className="popup-title">Thanks - your message has been received and one of our team will get back to you.</h2>
        </>
      ) : (
        <>
          <p></p>
          <FormControl fullWidth className='recipient-form'>
            <span>Recipient:</span>
            <Select
              value={recipients}
              onChange={(e) => setRecipients(e.target.value)}
              className="recipient-select"
              displayEmpty
              renderValue={(selected) => selected}
              MenuProps={{
                PaperProps: {
                  style: {
                    borderRadius: '12px',
                    marginTop: '8px',
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)'
                  }
                }
              }}
            >
              {['Branch', 'Payroll'].map((name) => (
                <MenuItem key={name} value={name} className="recipient-checkbox">
                  <ListItemText primary={name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Enter your message here..."
          />

          {error && <p className="error-message">{error}</p>}

          <div className="btns btns-contact">
            <button
              className="btn btn-confirm"
              onClick={handleSubmit}
              disabled={!message.trim() || !recipients}
            >
              Submit
            </button>
          </div>
        </>
      )}
    </Popup>
  );
};

export default ContactPopup; 